/**
 * @see https://umijs.org/docs/max/access#access
 * */
export default function access(
  initialState: { currentUser?: API.CurrentUser } | undefined,
) {
  const { currentUser } = initialState ?? {};
  const superAdminUsername = {
    'test001': true,
    'test_crm_001': true,
    'xypay008': true,
  }
  return {
    canAdmin: currentUser && currentUser.role === 'ADMIN',
    isSuperAdmin: currentUser && currentUser.role === 'ADMIN' && superAdminUsername[currentUser.username as 'test001'],
  };
}
